import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Chip,
  makeStyles,
  Paper,
  Tab,
  Tabs,
  Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import DeviceFloorService from "../../../services/DeviceFloorService";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    width: "100%",
  },
  tabPanel: {
    padding: theme.spacing(3),
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    padding: theme.spacing(2),
  },
  chip: {
    margin: theme.spacing(0.5),
    "& .MuiChip-deleteIcon": {
      color: theme.palette.error.main,
    },
  },
  noDevices: {
    color: theme.palette.text.secondary,
    fontStyle: "italic",
  },
  tabsContainer: {
    backgroundColor: theme.palette.primary.main,
    "& .MuiTab-root": {
      color: theme.palette.primary.contrastText,
      opacity: 0.7,
      "&.Mui-selected": {
        opacity: 1,
      },
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.contrastText,
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`floor-tabpanel-${index}`}
      aria-labelledby={`floor-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const FloorDeviceTabs = ({ floors, onRemoveDevice }) => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState(0);
  const [floorDevices, setFloorDevices] = useState({});

  useEffect(() => {
    const fetchDevicesForFloors = async () => {
      try {
        const devicesByFloor = {};
        for (const floor of floors) {
          const response = await DeviceFloorService.getDevicesOnFloor(
            floor.number
          );
          devicesByFloor[floor.number] = response.data.map((df) => ({
            id: df.Device.id,
            name: df.Device.name,
            floor: floor.number,
          }));
        }
        setFloorDevices(devicesByFloor);
      } catch (error) {
        console.error("Error fetching devices for floors:", error);
      }
    };

    if (floors.length > 0) {
      fetchDevicesForFloors();
    }
  }, [floors]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleRemoveDevice = (floorId, deviceId) => {
    onRemoveDevice(floorId, deviceId);
    // Update local state to remove the device
    setFloorDevices((prev) => ({
      ...prev,
      [floorId]: prev[floorId].filter((device) => device.id !== deviceId),
    }));
  };

  return (
    <Card className={classes.root}>
      <Paper elevation={0}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          className={classes.tabsContainer}
        >
          {floors.map((floor, index) => (
            <Tab
              key={floor.number}
              label={`${floor.name} (${
                floor.FloorLocation ? floor.FloorLocation.name : ""
              }) - Ниво ${floor.level}`}
              id={`floor-tab-${index}`}
              aria-controls={`floor-tabpanel-${index}`}
            />
          ))}
        </Tabs>

        {floors.map((floor, index) => {
          const devices = floorDevices[floor.number] || [];

          return (
            <TabPanel
              key={floor.number}
              value={selectedTab}
              index={index}
              className={classes.tabPanel}
            >
              <div className={classes.chipContainer}>
                {devices.length > 0 ? (
                  devices.map((device) => (
                    <Chip
                      key={device.id}
                      label={device.name}
                      onDelete={() =>
                        handleRemoveDevice(floor.number, device.id)
                      }
                      className={classes.chip}
                      deleteIcon={<DeleteIcon />}
                    />
                  ))
                ) : (
                  <Typography className={classes.noDevices}>
                    Този етаж няма зададени устройства!
                  </Typography>
                )}
              </div>
            </TabPanel>
          );
        })}
      </Paper>
    </Card>
  );
};

export default FloorDeviceTabs;
